import { createApp } from 'vue';
import { defineCustomElements, addTheme } from '@scania/components';
import { theme as scania } from '@scania/theme-light';
import App from './App';
import { createPinia } from 'pinia';
import { createRouter } from './router';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import adobeLaunchEventHandler from './plugins/adobeLaunchEventHandler';
import { useMainStore } from './store';
import { useCookieStore } from './store/cookie';
import i18n from './plugins/i18n';
import { datadogRum } from '@datadog/browser-rum';


import { faMagnifyingGlass, faSpinner, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
library.add(faMagnifyingGlass, faSpinner, faCircleInfo);

defineCustomElements();
addTheme(scania);

// const isLocalhost = ['localhost', '127.0.0.1'].includes(String(window?.location?.hostname || ''));
// const DEV_REDIRECT_SIGNATURE = 'YWNjZXNzVG9EZXZFbnY';
// const DEV_REDIRECT_BYPASS_KEY = 'dsDeMarketDevRedirectBypassUntil';
// const DEV_REDIRECT_BYPASS_TTL_MS = 7 * 24 * 60 * 60 * 1000;

// if (
//   process.env.VUE_APP_ENV === 'dev' &&
//   !isLocalhost &&
//   String(window?.location?.pathname || '').startsWith('/market/de')
// ) {
//   const searchParams = new URLSearchParams(window.location.search || '');
//   const hasValidSignature = searchParams.get('signature') === DEV_REDIRECT_SIGNATURE;
//   let redirectToProd = true;

//   if (hasValidSignature) {
//     redirectToProd = false;
//     try {
//       window.localStorage.setItem(DEV_REDIRECT_BYPASS_KEY, String(Date.now() + DEV_REDIRECT_BYPASS_TTL_MS));
//     } catch (error) {
//       // Ignore storage errors and allow bypass for this request.
//     }

//     searchParams.delete('signature');
//     const nextQuery = searchParams.toString();
//     const nextUrl = `${window.location.pathname}${nextQuery ? `?${nextQuery}` : ''}${window.location.hash || ''}`;
//     window.history.replaceState({}, '', nextUrl);
//   }

//   if (redirectToProd) {
//     try {
//       const bypassUntil = Number(window.localStorage.getItem(DEV_REDIRECT_BYPASS_KEY) || 0);
//       if (bypassUntil > Date.now()) {
//         redirectToProd = false;
//       } else if (bypassUntil) {
//         window.localStorage.removeItem(DEV_REDIRECT_BYPASS_KEY);
//       }
//     } catch (error) {
//       // Ignore storage access errors and keep default redirect behavior.
//     }
//   }

//   if (redirectToProd) window.location.replace(`https://buy.scania.com${window?.location?.pathname || '/market/de/active'}`);
// }

const app = createApp(App);
app.component('FontAwesomeIcon', FontAwesomeIcon);

app.use(createPinia());

const store = useMainStore();
const cookieStore = useCookieStore();
app.use(i18n, store);
app.use(adobeLaunchEventHandler, store);
const router = createRouter(app);
app.use(router);

const datadogSetup = () => {
  datadogRum.init({
    applicationId: '5189322c-823d-4268-a5ff-1deb26900fc1',
    clientToken: 'pub07908acb161c95c47fad68f537ea64dd',
    site: 'datadoghq.eu',
    service: 'digital-sales-public',
    env: process.env.VUE_APP_ENV,
    // Specify a version number to identify the deployed version of your application in Datadog
    version: process.env.VUE_APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 30,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    trackingConsent: 'not-granted',
  });
};

datadogSetup();

app.mount('#app');
